/* ============================================================
   DRAWER
============================================================ */
function openDrawer() {
  document.getElementById('drawer').classList.add('open');
  document.getElementById('drawerOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeDrawer() {
  document.getElementById('drawer').classList.remove('open');
  document.getElementById('drawerOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.product-overlay.open').forEach(function(el) { el.classList.remove('open'); });
    document.body.style.overflow = '';
    closeDrawer();
  }
});

/* ============================================================
   SCROLL REVEAL
============================================================ */
var reveals = document.querySelectorAll('.reveal');
var revealObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.1 });
reveals.forEach(function(el) { revealObs.observe(el); });

/* ============================================================
   VIDEO CAROUSEL
============================================================ */
var track = document.getElementById('videoTrack');
if (track) {
  var items = track.querySelectorAll('.video-item');
  var dots = document.querySelectorAll('.video-dot');

  function setActive(index) {
    items.forEach(function(el, i) {
      el.classList.toggle('active', i === index);
      var vid = el.querySelector('.video-el');
      if (vid) {
        if (i === index) { vid.play().catch(function() {}); }
        else { vid.pause(); vid.currentTime = 0; }
      }
    });
    dots.forEach(function(el, i) { el.classList.toggle('active', i === index); });
    var activeEl = items[index];
    if (!activeEl) return;
    var trackRect = track.getBoundingClientRect();
    var itemRect = activeEl.getBoundingClientRect();
    var offset = itemRect.left - trackRect.left - (trackRect.width / 2) + (itemRect.width / 2);
    track.scrollBy({ left: offset, behavior: 'smooth' });
  }

  items.forEach(function(el, i) { el.addEventListener('click', function() { setActive(i); }); });
  dots.forEach(function(el, i) { el.addEventListener('click', function() { setActive(i); }); });

  var isDown = false, startX, scrollLeft;
  track.addEventListener('mousedown', function(e) {
    isDown = true; track.classList.add('dragging');
    startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
  });
  track.addEventListener('mouseleave', function() { isDown = false; track.classList.remove('dragging'); });
  track.addEventListener('mouseup', function() { isDown = false; track.classList.remove('dragging'); });
  track.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    e.preventDefault();
    track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX) * 1.4;
  });
}

/* ============================================================
   MUTE / UNMUTE
============================================================ */
function toggleMute(event, btn) {
  event.stopPropagation();
  var vid = btn.closest('.video-item').querySelector('.video-el');
  if (!vid) return;
  vid.muted = !vid.muted;
  btn.querySelector('.icon-vol-on').style.display = vid.muted ? 'none' : 'block';
  btn.querySelector('.icon-vol-off').style.display = vid.muted ? 'block' : 'none';
}

/* ============================================================
   SMOOTH ANCHORS
============================================================ */
document.querySelectorAll('a[href^="#"]').forEach(function(a) {
  a.addEventListener('click', function(e) {
    var t = document.querySelector(a.getAttribute('href'));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});

/* ============================================================
   SEARCH
============================================================ */
function toggleSearch() {
  var bar = document.getElementById('navSearchBar');
  if (bar) { var open = bar.classList.toggle('open'); if (open) bar.querySelector('input').focus(); }
}

/* ============================================================
   CART — ADD TO CART
============================================================ */
async function addToCart(variantId, quantity) {
  quantity = quantity || 1;
  try {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    });
    var data = await res.json();
    if (data.status) { alert('Error: ' + data.description); }
    else { await updateCartCount(); showCartNotification(data.title); }
  } catch(e) { console.error('Cart error', e); }
}

/* ============================================================
   CART — COMPRAR AHORA (página de producto)
============================================================ */
async function buyNow() {
  var vidEl = document.getElementById('selected-variant-id');
  var vid = vidEl ? vidEl.value : null;
  if (!vid) return;
  try {
    await fetch('/cart/clear.js', { method: 'POST' });
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
    });
    var data = await res.json();
    if (!data.status) { window.location.href = '/checkout'; }
    else { alert('Error: ' + data.description); }
  } catch(e) { window.location.href = '/checkout'; }
}

/* ============================================================
   CART — COMPRAR AHORA DIRECTO (cards del home/coleccion)
============================================================ */
async function buyNowDirect(variantId) {
  try {
    await fetch('/cart/clear.js', { method: 'POST' });
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    });
    var data = await res.json();
    if (!data.status) { window.location.href = '/checkout'; }
    else { alert('Error: ' + data.description); }
  } catch(e) { window.location.href = '/checkout'; }
}

/* ============================================================
   CART — CONTADOR Y NOTIFICACION
============================================================ */
async function updateCartCount() {
  try {
    var res = await fetch('/cart.js');
    var cart = await res.json();
    updateFloatingCart(cart.item_count);
    var badge = document.getElementById('cart-count');
    if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
  } catch(e) {}
}

function showCartNotification(title) {
  var n = document.getElementById('cart-notification');
  if (!n) {
    n = document.createElement('div');
    n.id = 'cart-notification';
    n.style.cssText = 'position:fixed;bottom:100px;left:50%;transform:translateX(-50%);background:var(--blue-dark);color:white;font-family:var(--font-display);font-size:14px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;padding:14px 28px;border-radius:8px;z-index:600;box-shadow:0 8px 32px rgba(0,0,0,0.3);transition:opacity 0.3s ease;white-space:nowrap;';
    document.body.appendChild(n);
  }
  n.textContent = '✓ ' + title + ' agregado al carrito';
  n.style.opacity = '1';
  clearTimeout(n._timer);
  n._timer = setTimeout(function() { n.style.opacity = '0'; }, 3000);
}

function updateFloatingCart(count) {
  var badge = document.getElementById('floating-cart-count');
  if (badge) { badge.textContent = count; badge.style.display = count > 0 ? 'flex' : 'none'; }
}

/* ============================================================
   VARIANTES DE PRODUCTO
============================================================ */
function selectVariant(btn, optionIndex, value, variantId) {
  if (typeof selectedOptions === 'undefined') return;
  selectedOptions[optionIndex] = value;
  var group = btn.closest('.variant-options') || btn.closest('.ps-option-btns');
  if (group) { group.querySelectorAll('.variant-btn, .ps-variant-btn').forEach(function(b) { b.classList.remove('active'); }); }
  btn.classList.add('active');
  var label = document.getElementById('opt-label-' + optionIndex);
  if (label) label.textContent = value;
  if (typeof productVariants === 'undefined') return;
  var matched = productVariants.find(function(v) {
    return v.options.every(function(opt, i) { return selectedOptions[i] === undefined || selectedOptions[i] === opt; });
  });
  if (matched) {
    var v1 = document.getElementById('selected-variant-id');
    var v2 = document.getElementById('selected-variant-id-bottom');
    if (v1) v1.value = matched.id;
    if (v2) v2.value = matched.id;
    var fmt = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 }).format(matched.price / 100);
    var p1 = document.getElementById('ps-price-display');
    var p2 = document.getElementById('ps-price-bottom');
    if (p1) p1.textContent = fmt;
    if (p2) p2.textContent = fmt;
    if (matched.featured_image) { var img = document.getElementById('psMainImgEl'); if (img) img.src = matched.featured_image.src; }
  }
}

/* ============================================================
   DOMCONTENTLOADED
============================================================ */
document.addEventListener('DOMContentLoaded', function() {

  /* ----- HERO VIDEO: cargar solo el que corresponde al dispositivo ----- */
  var isMobile = window.innerWidth < 768;
  var vDesktop = document.getElementById('hero-video-desktop');
  var vMobile  = document.getElementById('hero-video-mobile');

  function loadHeroVideo(el) {
    if (!el) return;
    var src = el.getAttribute('data-src');
    if (!src) return;
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    el.appendChild(source);
    el.style.display = 'block';
    el.load();
    el.play().catch(function() {});
  }

  if (isMobile) {
    loadHeroVideo(vMobile);
  } else {
    loadHeroVideo(vDesktop);
  }

  /* ----- Autoplay carrusel de videos ----- */
  document.querySelectorAll('.video-el').forEach(function(vid) {
    vid.play().catch(function() {});
  });

  /* ----- Carrito flotante ----- */
  var cartBtn = document.createElement('a');
  cartBtn.href = '/cart';
  cartBtn.id = 'floating-cart';
  cartBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><span id="floating-cart-count" style="display:none;">0</span>';
  document.body.appendChild(cartBtn);

  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { updateFloatingCart(c.item_count); }).catch(function() {});

  /* ----- Animaciones ----- */
  initHeroAnimations();
  initScrollAnimations();
});

/* ============================================================
   ANIMACIONES HERO
============================================================ */
function initHeroAnimations() {
  var hero = document.querySelector('.hero');
  if (!hero) return;
  var h1 = hero.querySelector('h1');
  var eyebrow = hero.querySelector('.hero-eyebrow');
  var sub = hero.querySelector('.hero-sub');
  var ctas = hero.querySelector('.hero-ctas');
  [h1, eyebrow, sub, ctas].forEach(function(el) {
    if (el) { el.style.opacity = '0'; el.style.transition = 'opacity 0.9s ease'; }
  });
  setTimeout(function() { if (eyebrow) eyebrow.style.opacity = '1'; }, 200);
  setTimeout(function() { if (h1) h1.style.opacity = '1'; }, 500);
  setTimeout(function() { if (sub) sub.style.opacity = '1'; }, 900);
  setTimeout(function() { if (ctas) ctas.style.opacity = '1'; }, 1200);
}

/* ============================================================
   ANIMACIONES DE SCROLL
============================================================ */
function initScrollAnimations() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.trust-item').forEach(function(el, i) {
    el.classList.add('anim-fade-up', 'anim-delay-' + (i + 1)); observer.observe(el);
  });
  document.querySelectorAll('.product-card').forEach(function(el, i) {
    el.classList.add('anim-zoom-in', 'anim-delay-' + (i + 1)); observer.observe(el);
  });
  var brandGrid = document.querySelector('.brand-grid');
  if (brandGrid) { brandGrid.classList.add('anim-slide-left'); observer.observe(brandGrid); }
  document.querySelectorAll('.why-card').forEach(function(el, i) {
    el.classList.add('anim-fade-up', 'anim-delay-' + (i + 1)); observer.observe(el);
  });
  document.querySelectorAll('.video-item').forEach(function(el, i) {
    el.classList.add('anim-zoom-in', 'anim-delay-' + ((i % 5) + 1)); observer.observe(el);
  });
  var ctaInner = document.querySelector('.cta-section .section-inner');
  if (ctaInner) { ctaInner.classList.add('anim-zoom-in'); observer.observe(ctaInner); }
  document.querySelectorAll('.blog-card').forEach(function(el, i) {
    el.classList.add('anim-fade-up', 'anim-delay-' + (i + 1)); observer.observe(el);
  });
}
/* ============================================================
   ANIMACIONES DE SCROLL - pegar al final de hydrix.js
============================================================ */

/* --- Fade in hero --- */
function initHeroAnimations() {
  var heroSection = document.querySelector('.hero');
  if (!heroSection) return;

  var h1 = heroSection.querySelector('h1');
  var eyebrow = heroSection.querySelector('.hero-eyebrow');
  var sub = heroSection.querySelector('.hero-sub');
  var ctas = heroSection.querySelector('.hero-ctas');

  [h1, eyebrow, sub, ctas].forEach(function(el) {
    if (el) { el.style.opacity = '0'; el.style.transition = 'opacity 0.9s ease'; }
  });

  setTimeout(function() { if (eyebrow) eyebrow.style.opacity = '1'; }, 200);
  setTimeout(function() { if (h1) h1.style.opacity = '1'; }, 500);
  setTimeout(function() { if (sub) sub.style.opacity = '1'; }, 900);
  setTimeout(function() { if (ctas) ctas.style.opacity = '1'; }, 1200);
}

/* --- Scroll Observer --- */
function initScrollAnimations() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

  // Trust bar - fade up uno a uno
  document.querySelectorAll('.trust-item').forEach(function(el, i) {
    el.classList.add('anim-fade-up', 'anim-delay-' + (i + 1));
    observer.observe(el);
  });

  // Productos - zoom in uno a uno
  document.querySelectorAll('.product-card').forEach(function(el, i) {
    el.classList.add('anim-zoom-in', 'anim-delay-' + (i + 1));
    observer.observe(el);
  });

  // Brand story - slide desde izquierda
  var brandGrid = document.querySelector('.brand-grid');
  if (brandGrid) {
    brandGrid.classList.add('anim-slide-left');
    observer.observe(brandGrid);
  }

  // Why buy - fade up uno a uno
  document.querySelectorAll('.why-card').forEach(function(el, i) {
    el.classList.add('anim-fade-up', 'anim-delay-' + (i + 1));
    observer.observe(el);
  });

  // Videos - zoom in escalonado
  document.querySelectorAll('.video-item').forEach(function(el, i) {
    el.classList.add('anim-zoom-in', 'anim-delay-' + ((i % 5) + 1));
    observer.observe(el);
  });

  // CTA banner - zoom in suave
  var ctaInner = document.querySelector('.cta-section .section-inner');
  if (ctaInner) {
    ctaInner.classList.add('anim-zoom-in');
    observer.observe(ctaInner);
  }

  // Blog - slide up uno a uno
  document.querySelectorAll('.blog-card').forEach(function(el, i) {
    el.classList.add('anim-fade-up', 'anim-delay-' + (i + 1));
    observer.observe(el);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initHeroAnimations();
  initScrollAnimations();
});

/* ============================================================
   CART + CHECKOUT FIX - reemplaza addToCart y buyNow en hydrix.js
============================================================ */
async function addToCart(variantId, quantity) {
  quantity = quantity || 1;
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    });
    const data = await res.json();
    if (data.status) {
      alert("Error: " + data.description);
    } else {
      updateCartCount();
      showCartNotification(data.title);
    }
  } catch(e) { console.error("Cart error", e); }
}

async function buyNow() {
  var vidEl = document.getElementById("selected-variant-id");
  var vid = vidEl ? vidEl.value : null;
  if (!vid) return;
  try {
    await fetch("/cart/clear.js", { method: "POST" });
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
    });
    const data = await res.json();
    if (!data.status) {
      window.location.href = "/checkout";
    } else {
      alert("Error: " + data.description);
    }
  } catch(e) {
    window.location.href = "/checkout";
  }
}

/* ============================================================
   CARRITO FLOTANTE
============================================================ */
document.addEventListener('DOMContentLoaded', function() {

  // Crear botón flotante
  var cartBtn = document.createElement('a');
  cartBtn.href = '/cart';
  cartBtn.id = 'floating-cart';
  cartBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><span id="floating-cart-count">0</span>';
  document.body.appendChild(cartBtn);

  // Cargar count inicial
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateFloatingCart(cart.item_count); })
    .catch(function() {});
});

function updateFloatingCart(count) {
  var badge = document.getElementById('floating-cart-count');
  if (badge) {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }
}

// Sobreescribir updateCartCount para incluir el flotante
async function updateCartCount() {
  var res = await fetch('/cart.js');
  var cart = await res.json();
  updateFloatingCart(cart.item_count);
  var badge = document.getElementById('cart-count');
  if (badge) {
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
  }
}
